import { createAction } from 'redux-act';

/**
 * Create the action
 */

export const hourVisibleUpdate = createAction('UPDATE_HOUR_VISIBLE');
export const teacherVisibleUpdate = createAction('UPDATE_TEACHER_VISIBLE');
export const roomVisibleUpdate = createAction('UPDATE_ROOM_VISIBLE');
export const colorVisibleUpdate = createAction('UPDATE_COLOR_VISIBLE');
export const otherTaskVisibleUpdate = createAction('UPDATE_OTHER_TASK_VISIBLE');
export const timeVisibleUpdate = createAction('UPDATE_TIME_VISIBLE');
export const startUpdate = createAction('UPDATE_AGENDA_START');
export const endUpdate = createAction('UPDATE_AGENDA_END');

export function toggleHourVisible(content) {
    return hourVisibleUpdate();
}

export function toggleTeacherVisible(content) {
    return teacherVisibleUpdate();
}

export function toggleRoomVisible(content) {
    return roomVisibleUpdate();
}

export function toggleColorVisible(content) {
    return colorVisibleUpdate();
}

export function toggleOtherTaskVisible(content) {
    return otherTaskVisibleUpdate();
}

export function toggleTimeVisible(content) {
    return timeVisibleUpdate();
}

export function agendaStart(start) {
    return startUpdate({
        start
    });
}

export function agendaEnd(end) {
    return endUpdate({
        end
    });
}